import { render } from "./ChartOfAssetDetails.vue?vue&type=template&id=30dd2866&scoped=true"
import script from "./ChartOfAssetDetails.vue?vue&type=script&lang=ts"
export * from "./ChartOfAssetDetails.vue?vue&type=script&lang=ts"

import "./ChartOfAssetDetails.vue?vue&type=style&index=0&id=30dd2866&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-30dd2866"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTable,QTr,QTh,QTd});
